module.exports = __webpack_public_path__ + "img/C03TechCallOfTheBull_ua.cb3d0740.webp";